import type { UserProfile } from 'types/auth';
import type { CompanyPermission, CompanyRole } from 'types/company-users';

export function hasCompanyPermission(user: UserProfile | null | undefined, permission: CompanyPermission) {
  return user?.role === 'admin' || (user?.role === 'customer' && !!user.permissions?.includes(permission));
}
export function assignableCompanyRoles(roles: CompanyRole[], user: UserProfile | null | undefined) {
  return hasCompanyPermission(user, 'company.users.assign_role') ? roles.filter(role => role.assignable) : [];
}
export function isOwnCompanyUser(user: UserProfile | null | undefined, customerId: number) {
  return user?.role === 'customer' && String(user.user_id) === String(customerId);
}

export function canAccessCompanySettings(user: UserProfile | null | undefined) {
  return hasCompanyPermission(user, 'company.users.read') || hasCompanyPermission(user, 'company.users.invite');
}
